import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "../../lib/api";

export default function AdminSystemTab({ errors, reload }) {
  const clearErrors = async () => { await api.delete("/admin/errors"); toast.success("Errors cleared."); reload(); };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">Client-side errors reported from visitors' browsers (latest 100).</p>
        {errors.length > 0 && (
          <button data-testid="clear-errors" onClick={clearErrors} className="shrink-0 inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-sm hover:bg-red-500/10 hover:text-red-500"><Trash2 className="w-4 h-4" /> Clear all</button>
        )}
      </div>
      <div className="rounded-2xl border border-border overflow-hidden">
        {errors.map((e) => (
          <div key={e.error_id} data-testid={`error-row-${e.error_id}`} className="px-5 py-4 border-b border-border last:border-0">
            <div className="flex items-center justify-between gap-3">
              <span className="font-mono-x text-[10px] tracking-widest px-2 py-0.5 rounded-full bg-red-500/10 text-red-500">{e.context || "unknown"}</span>
              <span className="text-xs text-muted-foreground shrink-0">{(e.created_at || "").replace("T", " ").slice(0, 19)}</span>
            </div>
            <div className="mt-1.5 text-sm font-medium break-words">{e.message}</div>
            {e.url && <div className="text-xs text-muted-foreground mt-0.5 truncate">{e.url}</div>}
          </div>
        ))}
        {errors.length === 0 && <div className="p-6 text-muted-foreground text-sm">No errors reported. All clear.</div>}
      </div>
    </div>
  );
}
